import { Normalized } from 'redux/schemas/normalized';
import { OfferingName } from 'redux/schemas/models/course';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';
import { AutoMatchingRule } from './mentoring-program-matching-rules';

export enum AutoMatchingType {
  RANDOM = 'random',
  RULE_BASED = 'rule_based',
}

export enum MentoringProgramMatchingType {
  PARTICIPANT_DRIVEN = 'participant_driven',
  AUTOMATED_MATCHING = 'auto',
}

export type MentoringProgram = {
  id: number;
  name: string;
  description: string;
  matchAnnouncementDate: string;
  releasedDate: string;
  endDate: string;
  isEnrolled: boolean;
  concurrentMentorConnection: number;
  headerColor: string;
  headerBackground: string;
  autoMatchingEnabled: boolean;
  autoMatchingType: AutoMatchingType;
  autoMatchingRules: AutoMatchingRule[];
  autoMatchingLastUpdated?: Date;
  mentorshipProgramEnrollment: MentoringProgramEnrollment;
  programAlias: {
    mentor: OfferingName;
    mentee: OfferingName;
  },
  guideline: string;
  isBeingDeleted?: boolean;
  isBeingCloned?: boolean;
  createdBy: {
    id: number;
    firstName: string;
    lastName: string;
    fullName: string;
  },
  mentorCapacityEnabled: boolean;
  pulseChecksEnabled: boolean;
  guidanceEnabled: boolean;
  guidesCount: number;
  aiMeetingPrepEnabled: boolean;
  matchingType: MentoringProgramMatchingType;
  showFindMentorModal?: boolean;
  programReflectionEnabled: boolean;
  programReflectionSession: number;
  setShowFindMentorModal?: (show: boolean) => void;
  adminsCount?: number;
};

export type MentoringProgramNormalized = Normalized<MentoringProgram, 'mentorshipProgramEnrollment'>;

export enum TargetAudience {
  MENTOR = 'mentor',
  MENTEE = 'mentee',
  MENTOR_AND_MENTEE = 'mentor_and_mentee',
}

export interface MentorshipProgramAliases {
  // Mentee Aliases
  MenteeAlias?: string;
  MenteesAlias?: string;
  menteeAlias?: string;
  menteesAlias?: string;
  MenteesTitleAlias?: string;
  MenteeTitleAlias?: string;
  // Mentor Aliases
  MentorAlias?: string;
  MentorsAlias?: string;
  mentorAlias?: string;
  mentorsAlias?: string;
  MentorsTitleAlias?: string;
  MentorTitleAlias?: string;
}
